import React, { useEffect, useState } from 'react'
import userControlledInput from '../../hooks/custom-hook/userControlledInput'
import axios from "axios"
import { Link } from 'react-router-dom/cjs/react-router-dom'
import swal from 'sweetalert'
import "./AddProduct.css"
import { baseURL } from '../../baseUrl.js'
import ImageKit from 'imagekit-javascript';

const AddProduct = () => {
  const title=userControlledInput('')
  const [category,setCategory]=useState('')
  const price=userControlledInput('')
  const rating=userControlledInput('')
  const stock=userControlledInput('')
  const brand=userControlledInput('')
  const [image,setImage]=useState(undefined)
  const [imgFile,setImgFile]=useState(undefined)
  const [imgUrlorfile,setimgUrlorFile]=useState(true)
  const [tags,setTags]=useState([])
  const [newTag,setNewTag]=useState([])
  const [newCategory,setNewCategory]=useState('')
  const [categories,setCategories]=useState([])
  const [processing,setProcessing]=useState(false)

  useEffect(()=>{
    axios.get(`${baseURL}/products/get/category`).then(res=>setCategories(res.data)).catch(err=>console.log(err))
  },[])
  useEffect(()=>{
    imgUrlorfile?setImage(''):setImage(undefined)
  },[imgUrlorfile])
  const removeTag=(t)=>{
    setTags(tags.filter(tags=>tags!=t))
  }
  const addTag=()=>{
    setTags([...tags,newTag])
    setNewTag('')
  }
const data={
  title:title.value,
  category:category,
  price:price.value,
  rating:rating.value,
  stock:stock.value,
  image:image,
  brand:brand.value,
  tags,
  fileId:undefined
}
const formData=new FormData()
if(imgFile){
  for(var i=0;i<imgFile.length;i++){

    formData.append('file',imgFile[i])
  }
}
for(let datakey in data){
  if(datakey=="tags"){
    for(let t in tags){
      formData.append('tags',[tags[t]])
    }
  }
  else{
  formData.append(datakey,data[datakey])
  }
}

const getAuthParams = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URI}/imagekit-auth`);
    const data = await response.json();
    return data;
  } catch (error) {
    swal("","file auth error","error")
    console.error('Error fetching authentication parameters:', error);
    setProcessing(false)
    return null;
  }
};

  const addProduct= async ()=>{
    setProcessing(true)
    if(category===''){
      swal("Please enter category","","error")
      setProcessing(false)

    }
    else if(imgFile===undefined){
      axios.post(`${baseURL}/products/add-product`,data)
      .then(res=>{
        setProcessing(false)
        swal("","Your product added!", "success")
      })
      .catch(err=>swal("Failed!", "Something went wrong", "error"))
    }
    else{
      if(imgFile){
        const authParams = await getAuthParams();
        if (authParams) {
          const { token, signature, expire } = authParams;
          const imageKit = new ImageKit({
            publicKey: process.env.REACT_APP_IMAGEKIT_PK,
            urlEndpoint: process.env.REACT_APP_IMAGEKIT_URI_ENDPOINT,
            authenticationEndpoint: `${process.env.REACT_APP_SERVER_URI}/file/upload`
          });
          imageKit.upload({
            file:imgFile[0],
            fileName:imgFile[0].name,
            signature: signature,
            token: token,
            expire: expire,
            folder:'/skgrocery/products'
          })
          .then(res=>{
            axios.post(`${baseURL}/products/add-product`,{...data,image:res.url,fileId:res.fileId})
            .then(res=>{
              setProcessing(false)
              swal("","Your product added!", "success")
            })
            .catch(err=>swal("Failed!", "Something went wrong", "error"))
          })
          .catch(err=>console.log(err))
        }
      }
    }
  }
  return (
    <div className='edit__product__main'>
      <h1>Add New Product</h1>
      <Link to='/admin'><p>back</p></Link>
      <div className='edit__product__container mb-5'>
        <div className='row'>
          <div className='col-md-4'>
          Title : <input type='text' {...title} style={{width:'80%'}}/>
          </div>
          <div className='col-md-5'>
          Price : <input className='mr-2' style={{width:'100px'}} type='number' {...price}/>
          Rating : <input style={{width:'100px'}} multiple  type='number' {...rating}/>
          </div>
        </div>
        <div className='row mt-3'>
        <div className='col'>
          Category : 
            <select className='ml-2 mr-2' value={category} onChange={(e)=>setCategory(e.target.value)}>
             <option selected hidden>Choose here</option>
              {categories.map((c,i)=>
              <option key={i}>{c._id}</option>)}
            </select>
          <input type='text' className='mr-2' onChange={(e)=>{setNewCategory(e.target.value)}}/>
          <button onClick={()=>{setCategories([...categories,{_id:newCategory}]);setCategory(newCategory)}}>add new category</button>
          </div>
        </div>
        <div className='mt-3'>
        Image :
           <label className="switch ml-2">
            <input type="checkbox" onChange={()=>{setimgUrlorFile(!imgUrlorfile)}}/>
              <span className="slider round"></span>
          </label>
         <input disabled={!imgUrlorfile} className='ml-2 mr-3' type='text' onChange={(e)=>setImage(e.target.value)} placeholder='image url'/>
         <input disabled={imgUrlorfile} type='file' multiple onChange={(e)=>{setImgFile(e.target.files)}}/>
        </div>
        <div className='mt-3 mb-2'>
        Stock : <input className='mr-2' type='text' {...stock}/>
        brand: <input type='text' {...brand}/>
        </div>
        <div>
          Tags : {tags&&tags.map((t,i) => 
          <span key={i}>
          <span style={{fontSize:'15px'}}className='mr-2 badge badge-pill  badge-success'>{t} <button className='edit__product__tags__remove' onClick={()=>removeTag(t)}>x</button></span>
          </span>)}
          <br></br>
          <input onChange={(e)=>setNewTag(e.target.value)} value={newTag} type='text'/><button className='ml-2' onClick={addTag}>add tag</button>
        </div>
        <button style={{width:'70px'}} disabled={processing} onClick={addProduct}>{processing?
        <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
          :
        'Submit'}</button>
      </div>
    </div>
  )
}

export default AddProduct
